if (!customElements.get("event-timer")) {
  class EventTimer extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
    }

    getTargetTimeParts() {
      const timeStr = (this.dataset.time || "").trim();
      if (timeStr) {
        const match = timeStr.match(/^(\d{1,2}):(\d{2})$/);
        if (match) {
          const hh = Number(match[1]);
          const mm = Number(match[2]);
          if (Number.isFinite(hh) && Number.isFinite(mm) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) {
            return { hours: hh, minutes: mm };
          }
        }
      }

      const hours = Number(this.dataset.hours);
      const minutes = Number(this.dataset.minutes);
      return {
        hours: Number.isFinite(hours) && hours >= 0 && hours <= 23 ? hours : 0,
        minutes: Number.isFinite(minutes) && minutes >= 0 && minutes <= 59 ? minutes : 0,
      };
    }

    getNextTargetTimestamp(nowTs) {
      const { hours, minutes } = this.getTargetTimeParts();
      const now = new Date(nowTs);
      const target = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes,
        0,
        0
      );

      if (nowTs >= target.getTime()) {
        target.setDate(target.getDate() + 1);
      }

      return target.getTime();
    }

    connectedCallback() {
      let hoursEl = this.querySelector(".hours .event-timer--column--number");
      let minutesEl = this.querySelector(".minutes .event-timer--column--number");
      let secondsEl = this.querySelector(".seconds .event-timer--column--number");

      this._hoursEl = hoursEl;
      this._minutesEl = minutesEl;
      this._secondsEl = secondsEl;

      this._targetTs = this.getNextTargetTimestamp(Date.now());
      this._tick();
    }

    disconnectedCallback() {
      if (this._timerId) {
        clearTimeout(this._timerId);
        this._timerId = null;
      }
    }

    _tick() {
      const now = Date.now();
      if (!this._targetTs || now >= this._targetTs) {
        this._targetTs = this.getNextTargetTimestamp(now);
      }

      let distance = this._targetTs - now;
      if (distance < 0) distance = 0;

      const hours = Math.floor(distance / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      if (this._hoursEl) this._hoursEl.textContent = EventTimer.addZero(hours);
      if (this._minutesEl) this._minutesEl.textContent = EventTimer.addZero(minutes);
      if (this._secondsEl) this._secondsEl.textContent = EventTimer.addZero(seconds);

      const nextDelay = 250 + (1000 - (now % 1000));
      this._timerId = setTimeout(this._tick, nextDelay);
    }

    static addZero(value) {
      return value < 10 && value >= 0 ? "0" + value : value;
    }
  }

  customElements.define("event-timer", EventTimer);
}
